import React, { useEffect, useState } from "react";

import { JSX } from "react/jsx-runtime";
import {
  Box,
  Checkbox,
  Chip,
  CircularProgress,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Stack,
  TablePagination,
} from "@mui/material";

import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { brown, pink } from "@mui/material/colors";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { EveButton } from "@eveworld/ui-components";
import ButtonSimulate from "../builder/buttons/ButtonSimulate";

async function getCharacters() {
  try {
    return await fetch(
      `https://blockchain-gateway-stillness.live.tech.evefrontier.com/smartcharacters`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    ).then((response) => response.json());
  } catch (error) {
    console.log(error);
  }
}

async function getCorpCharacters() {
  try {
    const requestData: QueryRequest[] = [
      {
        address: import.meta.env.VITE_WORLD_ADDRESS,
        query:
          'SELECT "characterId", "characterAddress", "corpId" FROM "eveworld__CharactersTable" ',
      },
    ];

    return await fetchTableData(requestData).then((data) => data);
  } catch (error) {
    console.log(error);
  }
}

async function getSmartAssemblyConfig(
  smartAssemblyId: string,
  subTable: string
) {
  try {
    //subTable should be SmartGateConfigT or SmartTurretConfi
    const requestData: QueryRequest[] = [
      {
        address: import.meta.env.VITE_WORLD_ADDRESS,
        query:
          'SELECT "systemId" FROM eveworld__"' +
          subTable +
          '" WHERE smartObjectId=' +
          smartAssemblyId.toString(),
      },
    ];

    return await fetchTableData(requestData).then((data) => data);
  } catch (error) {
    console.log(error);
  }
}

interface QueryRequest {
  address: string;
  query: string;
}

const fetchTableData = async (
  requestData: QueryRequest[],
  //apiUrl: string = "https://indexer.mud.garnetchain.com/q"
  apiUrl: string = "https://indexer.mud.pyropechain.com/q"
): Promise<any> => {
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching table data:", error);
    return null;
  }
};

class CharacterData {
  id!: string;
  address!: string;
  name!: string;
  corpId!: string;

  constructor(data: CharacterData) {
    Object.assign(this, data);
  }
}

function rowData(id: string, address: string, name: string, corpId: string) {
  return {
    id,
    address,
    name,
    corpId,
  };
}

function Row(props: { row: ReturnType<typeof rowData> }) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell
          component="th"
          scope="row"
          align="left"
          sx={{ fontSize: "13px" }}
        >
          {row.name}
        </TableCell>
        <TableCell
          component="th"
          scope="row"
          align="left"
          sx={{ fontSize: "13px" }}
        >
          {row.corpId}
        </TableCell>
        <TableCell>
          <Stack direction={"row"} spacing={1}>
            <ButtonSimulate CharacterAddress={row.address}></ButtonSimulate>
          </Stack>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 0, padding: 1, backgroundColor: brown[200] }}>
              <Typography variant="subtitle2" gutterBottom component="div">
                Further Details for {row.name}
              </Typography>
              <Typography variant="subtitle2" gutterBottom component="div">
                Character Address: {row.address}
              </Typography>
              {/* <Stack direction={"row"} spacing={1}>
                <ButtonBringOffline AssemblyId={row.id}></ButtonBringOffline>
                <ButtonBringOnline AssemblyId={row.id}></ButtonBringOnline>
              </Stack> */}
              {/* <br></br>
              <Stack direction={"row"} spacing={1}>
                <ButtonEditInfo
                  AssemblyId={row.id}
                  NewName={row.name}
                  NewDappUrl={row.dappUrl}
                  NewDescription={row.description}
                ></ButtonEditInfo>
              </Stack> */}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const OfficerPlayerList = ({
  smartCharacterAddress,
}: {
  smartCharacterAddress: string;
}): JSX.Element => {
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filterNames, setFilterNames] = useState<string[]>([]);
  const [filterCorps, setFilterCorps] = useState<string[]>(["98000002"]);
  const [corpCharacterDatas, setCorpCharacterDatas] = useState<
    CharacterData[] | null
  >(null);
  const [characterDatas, setCharacterDatas] = useState<CharacterData[] | null>(
    null
  );

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleChangeFilterNames = (
    event: SelectChangeEvent<typeof filterNames>
  ) => {
    const {
      target: { value },
    } = event;
    setFilterNames(typeof value === "string" ? value.split(",") : value);
    setPage(0);
  };

  const handleChangeFilterCorps = (
    event: SelectChangeEvent<typeof filterCorps>
  ) => {
    const {
      target: { value },
    } = event;
    setFilterCorps(typeof value === "string" ? value.split(",") : value);
    setPage(0);
  };

  let characterDatasFiltered: CharacterData[] = [];
  let characterNameList: JSX.Element[] = [];
  let characterCorpList: JSX.Element[] = [];

  useEffect(() => {
    let active = true;

    loadCorpCharacters();
    return () => {
      active = false;
    };

    async function loadCorpCharacters() {
      await getCorpCharacters().then(async (r) => {
        let tempCorpCharacters: CharacterData[] = [];

        for (var val of r.result[0]) {
          let corpCharacterData: CharacterData = {
            id: val[0],
            address: val[1],
            name: "",
            corpId: val[2],
          };

          tempCorpCharacters.push(corpCharacterData);
        }

        Promise.all(tempCorpCharacters);
        setCorpCharacterDatas(tempCorpCharacters);

        await getCharacters().then((r) => {
          const json = r.filter(
            (data: { address: string }) => data.address > ""
          );

          var tempCharacters: CharacterData[] = JSON.parse(
            JSON.stringify(json)
          );

          //extract the name etc. from the nested JSON
          if (tempCharacters != null) {
            const charactersComplete = tempCharacters.map(async (c, i) => {
              return c;
            });

            //match our corp characters to all chars, set corp id for just our corp characters so can filter on corpId > ""
            Promise.all(charactersComplete).then((r) => {
              // Map corpId to characters
              const charactersWithCorp = r.map((character) => {
                const matchingTableEntry = tempCorpCharacters.find(
                  (table) =>
                    table.address.toLowerCase() ===
                    character.address.toLowerCase()
                );
                return {
                  ...character,
                  corpId: matchingTableEntry?.corpId || "Not found",
                };
              });

              setCharacterDatas(
                charactersWithCorp.filter(
                  (data: { name: string; corpId: string }) =>
                    data.name > "" && data.corpId != "Not found"
                )
              );
            });
          }
        });
      });

      if (!active) {
        return;
      }

      setLoading(false);
    }
  }, [smartCharacterAddress]);

  if (loading) {
    return <CircularProgress />;
  } else {
    //***FILTER VALUE LISTS***

    let characterDatasForNameFilter = characterDatas;
    characterDatasForNameFilter?.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });

    characterNameList.push(
      <MenuItem value={""} key={"blank"} sx={{ fontSize: 12 }}>
        {""}
      </MenuItem>
    );

    characterDatasForNameFilter?.forEach((data) => {
      let shouldInclude = false;
      if (filterCorps.length > 0) {
        if (filterCorps.includes(data.corpId)) {
          shouldInclude = true;
        }
      } else {
        shouldInclude = true;
      }

      if (shouldInclude == true) {
        characterNameList.push(
          <MenuItem value={data.name} key={data.address} sx={{ fontSize: 12 }}>
            {data.name}
          </MenuItem>
        );
      }
    });

    let characterDatasForCorpFilter = characterDatas;
    characterDatasForCorpFilter?.sort((a, b) => {
      if (a.corpId < b.corpId) {
        return -1;
      }
      if (a.corpId > b.corpId) {
        return 1;
      }
      return 0;
    });

    characterCorpList.push(
      <MenuItem value={""} key={"blank"} sx={{ fontSize: 12 }}>
        {""}
      </MenuItem>
    );

    let corpIdUniqueList: string[] = [];
    characterDatasForCorpFilter?.forEach((data) => {
      if (corpIdUniqueList.includes(data.corpId) == false) {
        corpIdUniqueList.push(data.corpId);
        characterCorpList.push(
          <MenuItem value={data.corpId} key={data.corpId} sx={{ fontSize: 12 }}>
            <Checkbox
              checked={filterCorps.includes(data.corpId)}
              size="small"
            />
            {data.corpId}
          </MenuItem>
        );
      }
    });

    //***APPLY FILTERS***

    let characterDatasFiltered = characterDatas;

    if (characterDatasFiltered != null) {
      if (filterNames.length > 0) {
        characterDatasFiltered = characterDatasFiltered
          .filter((data) => filterNames.includes(data.name))
          .sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          });
      }

      if (filterCorps.length > 0) {
        characterDatasFiltered = characterDatasFiltered
          .filter((data) => filterCorps.includes(data.corpId))
          .sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          });
      }
    }

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 10 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    };

    return (
      <>
        <p>This is the Officer Player List page</p>
        <div className="players-container">
          <TableContainer component={Paper}>
            <Table stickyHeader size="small" aria-label="collapsible table">
              {/* header row */}
              <TableHead
                sx={{
                  "& .MuiTableCell-head": {
                    backgroundColor: brown[300],
                    color: pink[900],
                  },
                }}
              >
                <TableRow>
                  <TableCell />
                  <TableCell align="left" style={{ minWidth: "200px" }}>
                    Name
                  </TableCell>
                  <TableCell align="left" style={{ minWidth: "200px" }}>
                    Corp Id
                  </TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              {/* filter row */}
              <TableHead
                sx={{
                  "& .MuiTableCell-head": {
                    backgroundColor: brown[200],
                    color: pink[900],
                  },
                }}
              >
                <TableRow>
                  <TableCell>Filters:</TableCell>
                  <TableCell align="left" style={{ minWidth: "200px" }}>
                    <FormControl sx={{ m: 1, width: 200 }}>
                      <Select
                        id="filter-characterName"
                        value={filterNames}
                        label="Character Name"
                        onChange={handleChangeFilterNames}
                        multiple
                        renderValue={(selected) => (
                          <Box
                            sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                          >
                            {selected.map((value) => (
                              <Chip
                                key={value}
                                label={value}
                                sx={{
                                  "& .MuiChip-label": {
                                    color: pink[900],
                                  },
                                }}
                              />
                            ))}
                          </Box>
                        )}
                        MenuProps={MenuProps}
                        style={{
                          minWidth: "100%",
                          color: "black",
                          fontFamily: "Roboto",
                          fontSize: 12,
                        }}
                      >
                        {characterNameList}
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell align="left" style={{ minWidth: "200px" }}>
                    <FormControl sx={{ m: 1, width: 200 }}>
                      <Select
                        id="filter-characterCorp"
                        value={filterCorps}
                        label="Corp Id"
                        onChange={handleChangeFilterCorps}
                        multiple
                        renderValue={(selected) => (
                          <Box
                            sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                          >
                            {selected.map((value) => (
                              <Chip
                                key={value}
                                label={value}
                                sx={{
                                  "& .MuiChip-label": {
                                    color: pink[900],
                                  },
                                }}
                              />
                            ))}
                          </Box>
                        )}
                        MenuProps={MenuProps}
                        style={{
                          minWidth: "100%",
                          color: "black",
                          fontFamily: "Roboto",
                          fontSize: 12,
                        }}
                      >
                        {characterCorpList}
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody
                sx={{
                  "& .MuiTableCell-root": {
                    color: pink[900],
                  },
                }}
              >
                {characterDatasFiltered &&
                  characterDatasFiltered
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((data: any) => <Row key={data.id} row={data} />)}
              </TableBody>
            </Table>
          </TableContainer>
          <Paper>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50]}
              component="div"
              count={characterDatasFiltered?.length ?? 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </div>
      </>
    );
  }
};

export default React.memo(OfficerPlayerList);
